module.exports = __webpack_public_path__ + "img/about_page_03.9ef55dac.jpg";